import { LOCATION } from './regions';

export const dictionary: Record<number, Record<string, string>> = {
  [LOCATION.MOSCOW_AND_AREA.ID]: {
    mainTabAboutDescription2:
      'Все проекты возводятся по единому стандарту качества. ПИК-Стандарт — это благоустроенные дворы-парки, подъезды на уровне земли, продуманная квартальная застройка, дома разной высоты и увеличенные окна, чтобы в каждой квартире было максимум солнечного света каждый день.',
  },
  [LOCATION.SPB_AND_AREA.ID]: {
    mainTabAboutDescription2:
      'Все проекты возводятся по единому стандарту качества. ПИК-Стандарт — это благоустроенные дворы-парки, парадные на уровне земли, продуманная квартальная застройка, дома разной высоты и увеличенные окна, чтобы в каждой квартире было максимум солнечного света каждый день.',
  },
};
